import styled from "styled-components";

export const RoyalTeam = styled.section`
display: flex;
align-items: flex-start;
justify-content: center;
flex-direction: column;
padding: 100px 100px;
`;

export const RoyalTeamTitle = styled.h2`
font-weight: 700;
font-size: 56px;
line-height: 68px;
letter-spacing: 0.01em;
text-transform: uppercase;
color: var(--white);
`;

export const RoyalTeamContent = styled.div`
padding-top: 150px;
display: flex;
align-items: center;
justify-content: center;
width: 100%;
`;

export const SplideSlide = styled.div`
padding-top: 150px;
display: flex;
align-items: center;
justify-content: center;
width: 100%;
`;